const OPENING_HOURS_DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday', 
];
var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));
const ACCESSIBILITY_WHEELCHAIR = 'Wheelchair';
const FRANCHISE_STORE = 'Franchise store';

export { ACCESSIBILITY_WHEELCHAIR, FRANCHISE_STORE, OPENING_HOURS_DAYS, OpenClosedStatus };
//# sourceMappingURL=types.js.map
